import { createAction } from '@reduxjs/toolkit';
import { SET_NEWSLETTER_INTERESTS, SET_NEWSLETTER_IS_LOADING, SET_NEWSLETTER_EMAIL, } from './actionTypes';
export const setNewsletterInterests = createAction(SET_NEWSLETTER_INTERESTS);
export const setNewsletterIsLoading = createAction(SET_NEWSLETTER_IS_LOADING);
export const setNewsletterEmail = createAction(SET_NEWSLETTER_EMAIL);
